
export abstract class SerializerOperator<T> {
    public abstract format(value: T): string;
}
